import _ from "lodash";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { IComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import * as RS from "react-sortable-hoc";

interface OwnProps {
    form: IComponentWithValidatedForm;
}

interface OwnState {
    show: boolean;
}

export class AuthorSortModal extends Comp.Base.BaseComponent<OwnProps, OwnState> {

    private SortableItem = RS.SortableElement((item: { author: Forms.AdminAbstract.AbstractAuthorData }) => {
        const role = _.find(M.Abstract.AbstractAuthorRoles.Values, (v) => v.id === item.author.roleId);
        const isPrimary = M.Abstract.AbstractAuthorRoles.isPrimary(item.author.roleId);
        return <div className="panel panel-default" style={{ cursor: "move", display: item.author.deleted ? "none" : "block" }}>
            <div className="panel-heading">
                <p>
                    {M.Generic.PersonHelper.getFullNameWithSuffix(item.author)}{" "}
                    {isPrimary ? <span className="mute">({role ? role.name : ""})</span> : null}
                </p>
            </div>
        </div>;
    });

    private SortableList = RS.SortableContainer((container: { authors: Forms.AdminAbstract.AbstractAuthorData[] }) => {
        return <div>
                {container.authors.map((x, i) => <this.SortableItem author={x} key={i} index={i} />)}
            </div>;
    });

    public constructor(props: any) {
        super(props);

        this.state = {
            show: false,
        };
    }

    public close() {
        this.setState({
            ...this.state,
            show: false,
        });
    }

    public show() {
        this.setState({
            ...this.state,
            show: true,
        });
    }

    public render() {
        const formModel = this.props.form.getFormModelData<Forms.AdminAbstract.AbstractAuthorshipData>();

        const modalProps: BS.ModalProps = {
            backdrop: true,
            bsStyle: "lg",
            keyboard: true,
            onEscapeKeyDown: () => this.close(),
            onHide: () => {},
            show: this.state.show,
        } as any; // needed "as any" here because "onEscapeKeyDown" does not exist in the latest typed definitions of react-bootstrap

        return <BS.Modal { ...modalProps }>
            <BS.Modal.Header
                bsClass="modal-header alert-info"
                closeButton
                onHide={() => this.close()}
            >
                <BS.Modal.Title>
                    Sort authors
                </BS.Modal.Title>
            </BS.Modal.Header>

            <BS.Modal.Body style={{ minHeight: "200px", position: "relative" }}>
                <this.SortableList
                    authors={formModel.authors}
                    helperClass="react-sort-sorting"
                    onSortEnd={(sort, e) => this.onSessionsSorted(sort)}
                    transitionDuration={150}
                />
            </BS.Modal.Body>

            <BS.Modal.Footer>
                <BS.Button bsStyle="primary" onClick={() => this.close()}>Close</BS.Button>
            </BS.Modal.Footer>
        </BS.Modal>;
    }

    private async onSessionsSorted(sortEnd: RS.SortEnd) {
        const formModel = this.props.form.getFormModelData<Forms.AdminAbstract.AbstractAuthorshipData>();
        formModel.authors = RS.arrayMove(formModel.authors, sortEnd.oldIndex, sortEnd.newIndex);
        let sort = 1;
        for (const a of formModel.authors) {
            a.index = sort - 1;
            a.sort = sort;
            sort++;
        }
        this.props.form.updateFormModelData(formModel);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/AuthorSortModal.tsx